import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";

export const AddNewTheme = () => {
  const [users, setUsers] = useState([]);
  const alert = useAlert();
  const request = async () => {
    const getUser = await await ApiService.post("get-all-active-users");
    console.log(getUser);
    setUsers(getUser.data.data);
  };

  useEffect(() => {
    request();
  }, []);
  return (
    <React.Fragment>
      <TrainingNavbar />
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="table-wrapper table-responsive">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-xs-12"
                    id="munch_learn_content_wrapper"
                  >
                    <div class="">
                      <Formik
                        initialValues={{
                          name: "",
                          due_date: "",
                          email: "",
                          theme: "",
                        }}
                        validate={(values) => {
                          const errors = {};
                          // if (!values.email) {
                          //     errors.email = "Required";
                          // } else if (
                          //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                          //         values.email
                          //     )
                          // ) {
                          //     errors.email = "Invalid email address";
                          // }
                          // return errors;
                        }}
                        onSubmit={async (values) => {
                          try {
                            const response = ApiService.post(
                              "create-theme",
                              values
                            );
                            console.log("res", response);
                            if (response.data.type === true) {
                              alert.success(response.data.msg);
                            }
                          } catch (error) {
                            console.log("err", error);
                            // if (response.data.type === false) {
                            alert.error("errororor");
                          }
                        }}
                      >
                        {({
                          isSubmitting,
                          values,
                          setFieldValue,
                          handleChange,
                        }) => (
                          <Form>
                            <div>
                              <div className="form-group">
                                <label>
                                  Presenter{" "}
                                  <span className="text-danger"> * </span>
                                </label>

                                <select
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  onChange={handleChange}
                                  value={values.name}
                                  required
                                >
                                  <option value="">--Select User--</option>

                                  {users.map((user, i) => (
                                    <option
                                      value={
                                        user.first_name + " " + user.last_name
                                      }
                                      key={i}
                                    >
                                      {user.first_name + " " + user.last_name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group">
                                <label>
                                  Presenter Email{" "}
                                  <span className="text-danger"> * </span>
                                </label>
                                <select
                                  type="text"
                                  className="form-control"
                                  name="email"
                                  onChange={handleChange}
                                  value={values.email}
                                  required
                                >
                                  <option value="">--Select User--</option>
                                  {users.map((user, i) => (
                                    <option value={user.email} key={i}>
                                      {user.email}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="form-group">
                                <label>
                                  Due Date{" "}
                                  <span className="text-danger"> * </span>
                                </label>
                                <div className="form-group">
                                  <DatePicker
                                    selected={values.due_date}
                                    dateFormat="MMMM d, yyyy"
                                    className="form-controls"
                                    name="due_date"
                                    onChange={(date) =>
                                      setFieldValue("due_date", date)
                                    }
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Theme</label>
                                <Field
                                  as="textarea"
                                  type="text"
                                  col="4"
                                  id="tpoic"
                                  className="form-control item"
                                  name="theme"
                                  placeholder="Enter Theme"
                                  requird
                                />
                              </div>
                              <div className="form-group">
                                <button
                                  type="submit"
                                  className="btn btn-block nt-button-color-default"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/add_new.js